module.exports = __webpack_public_path__ + "static/media/launch_port_marker.fe5ea100.svg";